module.exports = __webpack_public_path__ + "img/test.ef631e76.svg";